module.exports = __webpack_public_path__ + "img/w15b.c1819a26.jpg";